import { useRef } from 'react'
import { useDidUpdate } from 'rooks'

/**
 * Manages an animation with two transitions, like a menu (which can be transitioned to open or transitioned to closed)
 * @param {boolean} toggle Which state the element should be in
 * @return {[React.MutableRefObject<SVGAnimateTransformElement>, React.MutableRefObject<SVGAnimateTransformElement>]} Two SVG animation Refs, which correspond to the two animations
 */
export const useBinaryAnimation = (toggle: boolean) => {
	const phase1 = useRef<SVGAnimateTransformElement>(null)
	const phase2 = useRef<SVGAnimateTransformElement>(null)
	useDidUpdate(() => {
		if (toggle) {
			phase1?.current?.beginElement()
		} else {
			phase2?.current?.beginElement()
		}
	}, [toggle])
	return [phase1, phase2]
}
